import { graphql } from '@/generated/gql';

export const LOAD_PERMISSIONS_QUERY = graphql(/* GraphQL */ `
  query LoadPermissions {
    getPermissions {
      permissions
    }
  }
`);
